import React from "react";
import { getAutoStatusByDate } from "shared/utils/getAutoStatusByDate";
import { CarAvatar } from "shared/components";

interface AutoIconProps {
  lastActivityDate: string;
}

export const AutoIcon = ({ lastActivityDate }: AutoIconProps) => {
  return (
    <CarAvatar
      kind={"mobile"}
      activeStatus={getAutoStatusByDate(lastActivityDate)}
    />
  );
};
